"use client";

import { pushToDataLayer } from "@/helpers/gtag";
import styles from "./CourseCurriculum.module.scss";
import { useContext } from "react";
import { ModalContext } from "@/context/ModalContext";
import { getGlobalStateValue } from "@/context/utils";
import { IModalActions, ModalTypes } from "@/types/modal";

export default function ClientSideButton({ associatedPrograms = [] }) {
  const { modalDispatch } = useContext(ModalContext);

  const downloadBrochureCTA = () => {

   

    pushToDataLayer({
      event: "lead_initiate",
      cta_text: "Download Brochure",
      section_name: "Bottom Navigation Bar",
      page_type: getGlobalStateValue("pageType"),
    });

    const { attributes : {specializationText, Custom10PgType  }} =  associatedPrograms[0]
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.DownloadBrochure,
        modalData: { specializationText, Custom10PgType, programDetails: "Campus Immersion" },
      },
    });
  };

  return (
    <button onClick={downloadBrochureCTA} className={styles.curriculumbtn}>
      Explore Curriculum{" "}
      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 32 32">
        <g id="_2-Arrow_Down" data-name="2-Arrow Down">
          <path d="M26.29,20.29,18,28.59V0H16V28.59L7.71,20.29,6.29,21.71l10,10a1,1,0,0,0,1.41,0l10-10Z" />
        </g>
      </svg>
    </button>
  );
}
